import React from 'react'
import { useTableContext } from './TableProvider'
import { Button, Dropdown } from 'antd'
import UploadIcon from 'src/assets/images/document-upload.png'

const TableUploadButton: React.FC = () => {
  const {
    uploadDropdownItems = [],
    displayUploadButton = false,
    disableTableControl = false,
    handleUpload,
  } = useTableContext()

  if (!displayUploadButton || disableTableControl) {
    return <React.Fragment />
  }

  return (
    <Dropdown trigger={['click']} menu={{ items: uploadDropdownItems }}>
      <Button id='upload-button' icon={<img src={UploadIcon} alt='Upload Icon' />} onClick={handleUpload} />
    </Dropdown>
  )
}

export default TableUploadButton
